export const ServiceUrlTypeDict: any = {
	transactions: {
		name: "url_panel.transactions",
		description: "url_panel.transactions_des"
	},
	"active-positions": {
		name: "url_panel.positions",
		description: "url_panel.positions_des"
	},
	transfers: {
		name: "url_panel.transfers",
		description: "url_panel.transfers_des"
	}
};
